import React from 'react';
import Modal from '../../Modal/Modal';
import FormGroup from '../../FormGroup/FormGroup';

interface Props {
    onSaveClick: (from: number, to: number) => void;
    onClose?: () => void;
    title?: string;
}

interface State {
    title: string,
    isOpen: boolean,
    error: string | null,
    from: number,
    to: number
}

class ChangeDataSourceModal extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);

        this.state = {
            title: this.props.title || '',
            isOpen: true,
            error: null,
            from: 0,
            to: 0
        };

        this.onToChange = this.onToChange.bind(this);
        this.onFromChange = this.onFromChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.close = this.close.bind(this);
    }

    onToChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ to: parseInt(e.target.value) });
    }

    onFromChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ from: parseInt(e.target.value) });
    }

    onSaveClick(): void {

        this.props.onSaveClick(this.state.from, this.state.to);
        this.setState({ isOpen: false });
    }

    close(): void {
        this.setState({ isOpen: false });

        this.props.onClose && this.props.onClose();
    }

    render(): JSX.Element {
        const labelClass = 'col-12';
        const contentClass = 'col-7';

        return (
            <Modal state={this.state} close={this.close}>
                <p>The user must manually enter the Ingestion Config IDs for both the From and To data sources.</p>
                <FormGroup label="From Data Source (Ingestion Config ID):" labelClassName={labelClass} contentClassName={contentClass}>
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.from || ''}
                        onChange={this.onFromChange} >
                    </input>
                </FormGroup>

                <FormGroup label="To Data Source (Ingestion Config ID):" labelClassName={labelClass} contentClassName={contentClass}>
                    <input
                        className="form-control"
                        onChange={this.onToChange}
                        value={this.state.to || ''}>
                    </input>
                </FormGroup>

                <button className="btn cb-btn" onClick={this.onSaveClick}>Ok</button>
            </Modal>
        )
    }
}

export default ChangeDataSourceModal;
